import React from "react";

// styling
import style from "./whatsapp.module.scss";

export default function Whatsapp() {
  return (
    <div>
      <a
        href="https://wa.me/6281216593329?text=Halo%20Iqbal!%0APerkenalkan%20saya%20...%20ingin%20bertanya%20mengenai%20jasa%20pembuatan%20website"
        target="_blank"
        className={`${style.pusat_bantuan} d-none d-md-flex align-items-center`}
        rel="noreferrer"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="pusat bantuan"
          loading="lazy"
          className="img-fluid"
        />
      </a>
    </div>
  );
}
